import React from "react";
import Marquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "../lib/content";

export const EditorialMarquee = () => (
  <div data-testid="editorial-marquee" className="bg-navy border-y border-white/10 py-8 overflow-hidden">
    <Marquee speed={40} gradient={false} autoFill>
      {MARQUEE_WORDS.map((w, i) => (
        <div key={i} className="flex items-center">
          <span className="font-serif text-4xl sm:text-6xl font-light text-ivory/15 px-8 whitespace-nowrap">{w}</span>
          <span className="text-gold/40 text-2xl">✦</span>
        </div>
      ))}
    </Marquee>
  </div>
);
